import { render, staticRenderFns } from "./CadastrosMain.vue?vue&type=template&id=7e32cd58&"
import script from "./CadastrosMain.vue?vue&type=script&lang=js&"
export * from "./CadastrosMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports